import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    hovered,
    pressed
  } = _ref;
  return {
    previewLinkStyle: _objectSpread(_objectSpread({
      paddingLeft: 0,
      paddingRight: 0,
      color: designContext.get('preview/link-text-color', {
        interactiveState: pressed ? 'pressed' : hovered ? 'hovered' : 'default'
      }).toString(),
      cursor: 'pointer'
    }, designContext.get('preview/link-text-style').styles()), {}, {
      outline: 0,
      textDecoration: designContext.get('preview/link-text-underlined') ? 'underline' : 'none',
      textRendering: 'geometricPrecision',
      transition: 'color .2s ease',
      WebkitFontSmoothing: 'antialiased'
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map